
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function Hero() {
  const { t } = useTranslation();

  const handleScrollToCourses = () => {
    const coursesSection = document.getElementById('courses');
    if (coursesSection) {
      coursesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/f71ab5c3c78794f17fcbffb367351ee9.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            {t('Learn English Through Action Sports')}
          </h1>
          <h2 className="text-2xl md:text-3xl font-semibold mb-8 text-blue-300">
            {t('Master English with BMX & Skateboarding')}
          </h2>
          <p className="text-xl md:text-2xl mb-12 leading-relaxed max-w-3xl mx-auto">
            {t('Join our unique online English conversation classes where you\'ll learn through the exciting world of BMX and skateboarding. Perfect for action sports enthusiasts who want to improve their English skills!')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <a
              href="https://www.instagram.com/rampupenglish?igsh=NG9vZTBwY3F2bGw1&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap cursor-pointer font-medium rounded-lg transition-all duration-200 flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl px-8 py-4 text-lg text-xl px-10 py-5"
            >
              無料体験を予約
            </a>
            <button 
              onClick={handleScrollToCourses}
              className="whitespace-nowrap cursor-pointer font-medium rounded-lg transition-all duration-200 flex items-center justify-center border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-8 py-4 text-lg text-xl px-10 py-5 border-white text-white hover:bg-white hover:text-gray-900"
            >
              コースを見る
            </button>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
